import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CreditSetupResponse, CreditSetupStatus } from '@brightside-web/desktop/data-access/shared';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SkipTermsGuard implements CanActivate {

  creditStatusRoute: {[key: string]: any} = {
    [CreditSetupStatus.TERMS_ACCEPTED]: () => {
      this.router.navigate(['credit-setup', 'creation-waiting']);
    },
    [CreditSetupStatus.VERIFY_DIT]: () => {
      this.router.routeReuseStrategy.shouldReuseRoute =  () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/verification/identity/creditScore'], {state: {error: 'credit_dit_error'}});
    },
    [CreditSetupStatus.VERIFY_SMFA]: () => {
      this.router.navigate(['credit-setup', 'verify', 'smfa']);
    },
    [CreditSetupStatus.VERIFY_SMFA_TIMEOUT]: () => {
      this.router.navigate(['credit-setup', 'verify', 'smfa']);
    }
  }
  routeKeys: string[];

  constructor(private router: Router, private creditSetupService: CreditSetupService) {
    this.routeKeys = Object.keys(this.creditStatusRoute);
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.creditSetupService.getSetupStatus().pipe(
      map((resp: CreditSetupResponse) => {        
        if (this.routeKeys.includes(resp.status)) {
          this.creditStatusRoute[resp.status]();
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
